import { RootState } from '@store/store';

export const selectIsNotificationsOpen = (state: RootState) =>
  state.notifications.isOpen;
